module.exports = __webpack_public_path__ + "static/dataMonitor-6e3f4ae19acef6a006f079c378d7b764.mp4";